import React, { useCallback, useState } from 'react';
import { Link } from 'wouter';
import { TeamWithMembersData } from '../../../../api/ApiTypes';
import { Menu } from '../../../../ui';
import { DropMenuButton } from '../../../../ui/MenuButton';
import { useOnTeamAddUserViaPopup, useOnTeamDelete, useOnTeamRename } from '../../../actions/WorkspaceActions';
import { Flexer } from '../../../dashboard/elements/LayoutElements';

export const TeamActionMenu = ({ team, onClose }: { team: TeamWithMembersData, onClose: () => void }) => {

    const { onTeamAddUser } = useOnTeamAddUserViaPopup(team, onClose);
    const onTeamRename = useOnTeamRename(team.id, onClose);
    const onTeamDelete = useOnTeamDelete(team.id, onClose);

    return <Menu>
        <Menu.Section first>
            <Link to={`/manage/teams/${team.id}`}>
                <Menu.Item>
                    <Menu.ItemText>Open Team</Menu.ItemText>
                </Menu.Item>
            </Link>
        </Menu.Section>
        <Menu.Section>
            <Menu.Item onClick={onTeamAddUser}>
                <Menu.ItemText>Add People</Menu.ItemText>
            </Menu.Item>
            <Menu.Item onClick={onTeamRename}>
                <Menu.ItemText>Rename Team</Menu.ItemText>
            </Menu.Item>
        </Menu.Section>
        <Menu.Section>
            <Menu.Item onClick={onTeamDelete}>
                <Menu.ItemText>Delete Team</Menu.ItemText>
            </Menu.Item>
        </Menu.Section>
    </Menu>;
};

export const TeamActionMenuButton = ({ team }: { team: TeamWithMembersData }) => {

    const [open, setOpen] = useState(false);
    const setClosed = useCallback(() => setOpen(false), []);

    return <Flexer flex="row">
        <DropMenuButton icon="deqo://icons/hero/dots-horizontal" open={open} setOpen={setOpen}>
            <Flexer minWidth="10">
                <TeamActionMenu team={team} onClose={setClosed} />
            </Flexer>
        </DropMenuButton>
    </Flexer>;
};
